import { useEffect, useRef } from 'react'

import { useVerticalResizeHandle } from 'hooks'
import { useResponsive } from 'hooks/useResponsive'

import Header from './Header'
import MainContainer from './MainContainer'
import * as Styled from './styled'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'

const Timeline: React.FC = () => {
  const isMobile = useResponsive(MOBILE_SIZE_BREAKPOINT)
  const resizeLineRef = useRef<HTMLDivElement>(null)

  const { ref, onMouseDown } = useVerticalResizeHandle({
    minHeight: isMobile ? 180 : 280,
    maxHeight: isMobile ? 400 : 480
  })

  useEffect(() => {
    const resizeLineElement = resizeLineRef.current
    if (resizeLineElement) {
      resizeLineElement.addEventListener('touchstart', onMouseDown)
      resizeLineElement.addEventListener('mousedown', onMouseDown)
    }
    return () => {
      if (resizeLineElement) {
        resizeLineElement.removeEventListener('touchstart', onMouseDown)
        resizeLineElement.removeEventListener('mousedown', onMouseDown)
      }
    }
  }, [onMouseDown])

  return (
    <Styled.TimelineContainer ref={ref} className="timeline-container">
      <Styled.ResizeLineWrapper ref={resizeLineRef} />
      <Header />
      <MainContainer />
    </Styled.TimelineContainer>
  )
}

export default Timeline
